import React from 'react'
import styled from 'react-emotion'
import { regularFontFamily } from 'utils/style-helpers'
import { PageContainer } from 'components/Page'
import Hero from 'components/Hero'
import { LargeLinkButton } from 'components/LinkButton'
import Wrapper from 'components/Wrapper'
import ImageStrip from 'components/ImageStrip'

const HeroContent = styled.div`
  color: #fff;
  min-height: 400px;
  padding-top: 10px;

  h1 {
    font-size: 55px;
    text-transform: uppercase;

    span {
      ${regularFontFamily('light')}
      display: block;
      font-size: 40px;
      margin-top: 15px;
    }

    strong {
      font-weight: bold;
    }
  }
`

const ActionButton = styled(LargeLinkButton)`
  margin-top: 50px;
  width: 260px;
`

const SupportedSoftwares = styled(Wrapper)`
  padding-top: 50px;
  padding-bottom: 50px;
  text-align: center;

  p {
    color: #2c2c2c;
    font-size: 18px;
    margin-bottom: 60px;
    text-transform: uppercase;
  }
`

const IndexPage = ({ data }) => (
  <PageContainer>
    <Hero heroImage={data.heroImage}>
      <HeroContent>
        <h1>Save 80% more time <span>managing <strong>invoices</strong></span></h1>
        <ActionButton href="#sign-up">Learn More</ActionButton>
      </HeroContent>
    </Hero>
    <SupportedSoftwares>
      <p>Chouxbox works with your accounting software</p>
      <ImageStrip images={data.supportedSoftwares} />
    </SupportedSoftwares>
  </PageContainer>
)

export default IndexPage

export const query = graphql`
  query IndexQuery {
    heroImage: imageSharp(id: { regex: "/hero/home.jpg/" }) {
      sizes(maxWidth: 1920) {
        ...GatsbyImageSharpSizes
      }
    }
    supportedSoftwares: allSoftwaresYaml {
      edges {
        node {
          name
          logo {
            publicURL
          }
        }
      }
    }
    testimonials: allTestimonialsYaml {
      edges {
        node {
          author
          quote
          avatar {
            childImageSharp {
              sizes(maxWidth: 128) {
                ...GatsbyImageSharpSizes
              }
            }
          }
          background {
            childImageSharp {
              sizes(maxWidth: 1920) {
                ...GatsbyImageSharpSizes
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js